import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
// import ListSubheader from '@material-ui/core/ListSubheader';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Divider from '@material-ui/core/Divider';
import Popover from '@material-ui/core/Popover';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import API from '../../../../../api/axios';
import useTitle from 'hooks/useTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: '100%',
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
  },
  tile: {
    cursor: 'pointer',
  },
  paper: {
    padding: theme.spacing(1),
    minWidth: '250px',
  },
}));
const SlidesContainer = (props) => {
  useTitle('اسلایدر های سایت');
  const classes = useStyles();
  const { slides, onChangeField, sliderId, onDeleteSlide } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [slideKey, setSlideKey] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event, key) => {
    setAnchorEl(event.currentTarget);
    setSlideKey(key);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleTextField = (e) => {
    const { name, value } = e.target;
    onChangeField(slideKey, name, value);
  };
  const handleDeleteSlide = async (id) => {
    try {
      let data = {
        sliderId,
      };
      const response = await API.delete(`/api/v1/admin/slider/slide/${id}`, {
        data,
      });
      !!response && onDeleteSlide(id);
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };
  return !!slides ? (
    <>
      <Divider style={{ margin: '15px 0' }} />
      <div className={classes.root}>
        <GridList cellHeight={180} className={classes.gridList}>
          {slides.map((tile, index) => {
            const url =
              typeof tile.attachment === 'string'
                ? tile.attachment
                : URL.createObjectURL(tile.attachment);
            return (
              <GridListTile key={index}>
                <img
                  src={url}
                  alt={tile.title}
                  className={classes.tile}
                  onClick={(e) => handleClick(e, index)}
                />
                <GridListTileBar
                  title={tile.title}
                  subtitle={<span>{tile.description}</span>}
                  actionIcon={
                    !!tile._id ? (
                      <IconButton
                        className={classes.icon}
                        onClick={() => handleDeleteSlide(tile._id)}
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    ) : null
                  }
                />
              </GridListTile>
            );
          })}
        </GridList>
      </div>
      {open && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Paper className={classes.paper}>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <TextField
                  variant="standard"
                  color="secondary"
                  label="عنوان اسلاید"
                  name="title"
                  value={slides[slideKey].title}
                  onChange={handleTextField}
                  fullWidth
                />
              </Grid>
              <Grid item>
                <TextField
                  variant="standard"
                  color="secondary"
                  label="شرح اسلاید"
                  name="description"
                  value={slides[slideKey].description}
                  onChange={handleTextField}
                  fullWidth
                />
              </Grid>
              <Grid item>
                <TextField
                  variant="standard"
                  color="secondary"
                  label="لینک"
                  name="link"
                  value={slides[slideKey].link}
                  onChange={handleTextField}
                  style={{ direction: 'ltr' }}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Paper>
        </Popover>
      )}
    </>
  ) : null;
};
export default SlidesContainer;
